import React from "react";
import AdUnit from "./AdUnit";

// Define all ad placements
const AD_POSITIONS = {
  paragraphAds: [3, 14, 30], // Paragraph numbers for in-article ads
  nativeAd: "native-ad-300x250",
};

/**
 * Returns the appropriate ad components based on the paragraph position.
 */
export const getArticleAd = (paragraphNumber, adUnitsRegistered, isMobile) => {
  if (!adUnitsRegistered || !AD_POSITIONS.paragraphAds.includes(paragraphNumber)) return null;

  //console.log(`[ArticleAds] Rendering AdUnit: inarticle-paragraph${paragraphNumber} | Mobile: ${isMobile}`);

  switch (paragraphNumber) {
    case 3:
    return isMobile
        ? [<AdUnit adUnitCode="inarticle-paragraph3-mobile" key="ad-inarticle-paragraph3-mobile" />]
        : null;      
    case 14:
      return [
        <AdUnit adUnitCode="outstream_in_article" key="ad-outstream" />,
        <AdUnit adUnitCode={isMobile ? "inarticle-paragraph14-mobile" : "inarticle-paragraph14"} key={`ad-inarticle-paragraph14-${isMobile ? "mobile" : "desktop"}`} />
      ];

    default:
      return [
        <AdUnit adUnitCode={isMobile ? "inarticle-paragraph30-mobile" : "inarticle-paragraph30"} key={`ad-inarticle-paragraph30-${isMobile ? "mobile" : "desktop"}`} />,
      ];
  }
};


/**
 * Returns a native ad unit.
 */
export const getNativeAd = (adUnitsRegistered) => {
  if (!adUnitsRegistered) return null;

  return (
    <div className="mt-6 flex justify-center items-center" key="paywall-native-ad">
      <AdUnit adUnitCode={AD_POSITIONS.nativeAd} />
    </div>
  );
};
